export default "__VITE_ASSET__hUy5xAMs__"